setup();

function setup() { 
  if(document.querySelector(".cbd-test-list") === null) {
    return;
  }
  
  // Set starting expander icon
  Array.from(document.getElementsByClassName("cbd-test-list")).forEach(cbdListElement => {
    Array.from(document.getElementsByClassName("cbd-expander")).forEach(expanderElement => {
      expanderElement.innerHTML = getExpanderSVG(cbdListElement.classList.contains("cbd-collapsed")); // DUPL. LINE. REFACTOR *1-1
    });
  });

  // Expand on click
  Array.from(document.getElementsByClassName("cbd-product")).forEach(cbdElement => {
    Array.from(cbdElement.getElementsByClassName("cbd-product-title")).forEach(cbdTitleElement => {
      cbdTitleElement.addEventListener("click", function() { 
        let newExpandedStatus = "false";
        let newHiddenStatus = "true";
        if(cbdElement.ariaExpanded === "false") {
          newExpandedStatus = "true";
          newHiddenStatus = "false";
        }
        cbdElement.ariaExpanded = newExpandedStatus;

        let listArray = Array.from(cbdElement.getElementsByClassName("cbd-test-list"));
        listArray.forEach(cbdListElement => {
          cbdListElement.classList.toggle("cbd-collapsed");
          cbdListElement.ariaHidden = newHiddenStatus
          let expanderArray = Array.from(cbdTitleElement.getElementsByClassName("cbd-expander"));
          expanderArray.forEach(cbdExpanderElement => {
            cbdExpanderElement.innerHTML = getExpanderSVG(cbdListElement.classList.contains("cbd-collapsed")); // DUPL. LINE. REFACTOR *1-2
          });
        });
      }); 
    });
  }); 

  // Search bar
  let searchElement = document.getElementById("cbd-search");
  searchElement.addEventListener("input", function() {
    if(searchElement.value == "") {
      Array.from(document.getElementsByClassName("cbd-test-list")).forEach(testListElement => {
        testListElement.classList.add("cbd-collapsed");
        testListElement.classList.remove("cbd-invisible");
        testListElement.parentElement.classList.remove("cbd-invisible");
      });

      Array.from(document.getElementsByClassName("cbd-test")).forEach(testElement => {
        testElement.classList.remove("cbd-invisible");
      });
    } else {
      Array.from(document.getElementsByClassName("cbd-test-list")).forEach(testListElement => {
        let matchedCount = 0;
        Array.from(testListElement.getElementsByClassName("cbd-test")).forEach(testElement => {
          let foundMatch = false;
          if(testElement.querySelector(".cbd-test-lot-number a").innerHTML.includes(searchElement.value)) {
            foundMatch = true
          }

          if(testListElement.parentElement.querySelector(".cbd-product-title-text").innerHTML.toLowerCase().includes(searchElement.value.toLowerCase().trim())) {
            foundMatch = true;
          }

          if(foundMatch) {
            matchedCount++;
            replaceTag(testElement, "div");
            //testElement.classList.remove("cbd-invisible");
          } else {
            replaceTag(testElement, "del");
            //testElement.classList.add("cbd-invisible");
          }
        });

        if(matchedCount == 0) {
          testListElement.classList.add("cbd-collapsed");
          testListElement.classList.add("cbd-invisible");
          testListElement.parentElement.classList.add("cbd-invisible");
        } else {
          testListElement.classList.remove("cbd-collapsed");
          testListElement.classList.remove("cbd-invisible");
          testListElement.parentElement.classList.remove("cbd-invisible");
        }
      });
    }
  });

  // Sort products alphabetically
  let product_list = document.querySelector('#cbd-product-list');
  [...product_list.children]
    .sort((a,b)=>a.querySelector(".cbd-product-title-text").innerHTML.toLowerCase()>b.querySelector(".cbd-product-title-text").innerHTML.toLowerCase()?1:-1)
    .forEach(node=>product_list.appendChild(node));

  Array.from(document.getElementsByClassName("cbd-test-list")).forEach(listElement => {
    [...Array.from(listElement.getElementsByClassName("cbd-test"))]
      .sort((a,b)=>a.querySelector(".cbd-test-batch-date").innerHTML<b.querySelector(".cbd-test-batch-date").innerHTML?1:-1)
      .forEach(node=>listElement.appendChild(node));
  });
}

function replaceTag(element, newTag) {
   let newElement = document.createElement(newTag);
   newElement.className = element.className;
  
   // move all elements in the other container.
   while(element.firstChild) {
       newElement.appendChild(element.firstChild);
   }
   element.parentNode.replaceChild(newElement, element);
}

function getExpanderSVG(isCollapsed) {
  let points;
  if(isCollapsed) {
    // "6 15 12 09 18 15"
    points = "6 15 12 09 18 15"; 
  } else {
    points =  "6 09 12 15 18 09";
  }
  return `<svg xmlns="http://www.w3.org/2000/svg" width="24.0" height="24.0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-down"> <polyline points="${points}"></polyline></svg>`;
}